__webpack_require__.p = "/MyProjectShop/";